import AnimationMnager from '../module/animation';
import effectManager from '../module/effect';


const animation = new AnimationMnager();
const effect = new effectManager();


export default class notFoundManager {
    constructor() {


    }
    init(){
        TweenMax.to('#glass',2,{
            left:'56vw',
            delay:1.5,
            ease: Bounce.easeOut
        });
    }
    render(mouse){


    }
    resize(){

    }
}